import React from "react"
import styles from "./styles.scss"
import FaIcon from "@fortawesome/react-fontawesome"
import { Link } from "react-router-dom"
import cx from "classnames"
import Quote from "../../pages/LandingPage/CaseStudySection/Quote"
import { detect } from "detect-browser"

const browser = detect()

class CaseStudyCTA extends React.Component {
  render() {
    const { bioWidth, variant, caseStudy } = this.props

    const isIE = browser.name === "ie"

    return (
      <div
        className={cx(styles.container, {
          [styles.light]: variant === "light",
          [styles.defaultSecondaryColor]: isIE,
        })}
        style={
          !isIE
            ? { "--case-secondary-color": caseStudy.secondaryColor }
            : undefined
        }
      >
        <div className={styles.topMenu}>
          {caseStudy.tags.map(tag => (
            <span key={tag} className={styles.item}>
              {tag}
            </span>
          ))}
        </div>
        <Link to={caseStudy.path} className={styles.readMoreLink}>
          <div style={{ "--bio-width": bioWidth }} className={styles.bio}>
            <h2 dangerouslySetInnerHTML={{ __html: caseStudy.previewBio }} />
          </div>
        </Link>

        <div className={styles.quoteWrapper}>
          <div className={styles.readMore}>
            <div className={styles.readMoreBorder} />
            <Link to={caseStudy.path} className={styles.readMoreLink}>
              Läs mer om {caseStudy.project}{" "}
              <FaIcon className={styles.icon} icon={["fas", "angle-right"]} />
            </Link>
          </div>
          {caseStudy.quote && (
            <Quote
              quote={`”${caseStudy.quote}” - ${caseStudy.quoteAuthor}, ${
                caseStudy.quoteAuthorPosition
              }`}
              image={caseStudy.quoteImage}
              authorPosition={caseStudy.quoteAuthorPosition}
              author={caseStudy.quoteAuthor}
            />
          )}
        </div>
      </div>
    )
  }
}

export default CaseStudyCTA



// WEBPACK FOOTER //
// ./src/components/CaseStudyCTA/index.jsx